import type React from 'react';
// 손님 화면 색 규칙 — 2026-11-03 대표 "우리만의 컬러 블루로 가는게 좋을거같은데 인스타그램 컬러사용한거 존나짜침"(같은 날 '흑백 금지' 뒤).
// 규칙: ① 칸 제목 강조어·단계 번호 = 블루 글씨 그라데이션  ② 진행 선·고리 = 블루 그라데이션  ③ 아이콘 = 블루 한 가지, 동그라미 = 블루 14%
// 인스타그램 색(주황·분홍·보라)은 쓰지 않는다. 플랫폼 로고도 블루 한 결.
export const BRAND_BLUE = '#3182F6';
export const BRAND_BLUE_LIGHT = '#4C9AFF';
export const BRAND_GRADIENT = 'linear-gradient(120deg, #2563EB 0%, #3182F6 40%, #5EA2FF 75%, #A5CDFF 100%)';
/** 예전 이름(인스타 색 시절) — 이제 블루 그라데이션과 같다 */
export const IG_GRADIENT = BRAND_GRADIENT;
export const ACCENTS = ['#4C9AFF'] as const;
export const accent = (_i: number) => BRAND_BLUE_LIGHT;
export const tint = (hex: string, a = 0.14) => {
    const n = parseInt(hex.slice(1), 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};
/** 블루 글씨 그라데이션(칸 제목 강조어·단계 번호에만) — 검은 바탕에서 읽히게 밝은 쪽으로 */
export const gradientText: React.CSSProperties = {
    backgroundImage: 'linear-gradient(120deg, #3B82F6 0%, #60A5FA 50%, #BFDBFE 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
};
